module.exports = __webpack_public_path__ + "static/media/61pEEi55aKL._AC_SL1200_.c4e15648.jpg";